
<div>
  <table class="table table-striped table-condensed">
    <thead>
      <tr>
        <th>TLC</th>
        <th>Name</th>
        <th>Qualification</th>
        <th>E-Mail</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in data" :key="item.id">
        <td>{{ item.tlc }}</td>
        <td>{{ item.firstName + ' ' + item.lastName }}</td>
        <td>{{ item.qualification }}</td>
        <td>
          <a :href="'mailto:' + item.email">{{ item.companyEmail }}</a>
        </td>
      </tr>
    </tbody>
  </table>

  <p>
    E-Mail to all Crew Members:
    <a :href="mailtoLinkAll">Mail to all CrewMembers</a>
  </p>
</div>
